import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { ClipboardUtils } from '@framework/ClipboardUtils';
import { useTranslation } from 'react-i18next';
import type { ModelCommentThreadId, ModelId } from 'balus-common';

type Handler = () => void;

export const useCopyCommentThreadUrl = (threadId: ModelCommentThreadId, modelId: ModelId): Handler => {
  const { t } = useTranslation();
  return useCallback(async () => {
    const query = new URLSearchParams();

    query.set('targetCommentThread', threadId);
    query.set('targetModel', modelId);
    const url = `${window.location.origin}${window.location.pathname}?${query.toString()}`;

    try {
      await ClipboardUtils.copy(url);
      toast.success(t('common.message.copySuccess'));
    } catch (e) {
      console.warn('クリップボードへのコピーに失敗しました', e);
      toast.error(t('common.message.copyFailed'));
    }
  }, [t, threadId, modelId]);
};
